import { CONFIG } from '../../../../config'
import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { parseToMysqlFormat } from '../../../util/date.service'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/dashboard/expedicao-tps`

const ExpedicaoTpsHttp = {
  async getExpedicaoTps(pInicial, pFinal, companyGroupIds, tpsIds) {
    try {
      const dataInicial = parseToMysqlFormat(pInicial)
      const dataFinal = parseToMysqlFormat(pFinal)

      const url =
        BASE_URL +
        `?pInicial=${dataInicial}&pFinal=${dataFinal}&tps_ids=${tpsIds}&company_group_ids=${companyGroupIds}`
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },
}

export default ExpedicaoTpsHttp
